import React, { useEffect, useState } from "react";
import pckg from "../../../package.json";
import { useAppSelector } from "../../redux/hook";
import { Footer as FooterComponent } from "@dishopsaas/design-system";
import { Box } from "@mui/material";
import { loadLocalizeSdk, initializeLocalize } from "../../api/localize";
import { getColors } from "../../utils";
import { useResponsiveMaterial } from "../../hooks/useResponsive";

interface FooterProps {
  style?: React.CSSProperties;
}

const Footer: React.FC<FooterProps> = ({ style }) => {
  const { cgu, imagesDescription, logoUrl, socials } = useAppSelector(
    (state) => state.configurationReducer
  );
  const isMobile = useResponsiveMaterial("md", "down");

  const [currentLanguage, setCurrentLanguage] = useState("fr");

  const languageOptions = [
    { value: "fr", label: "FR" },
    { value: "en", label: "EN" },
  ];

  const socialLinks = [
    { type: "facebook", href: socials?.facebook || "#" },
    { type: "instagram", href: socials?.instagram || "#" },
    { type: "linkedin", href: socials?.linkedin || "#" },
  ];

  useEffect(() => {
    loadLocalizeSdk();
    initializeLocalize(true);
    window.Localize?.setLanguage(currentLanguage);
  }, [currentLanguage]);

  const handleLanguageChange = (lang: string) => {
    setCurrentLanguage(lang);
    window.Localize?.setLanguage(lang);
  };
  const { border, bglightgrey } = getColors();
  return (
    <Box
      sx={{
        borderTop: border,
        bgcolor: bglightgrey,
        ...style,
      }}
    >
      <FooterComponent
        isRow={!isMobile}
        brand="Dishop"
        logoSrc={logoUrl}
        link1={{ label: "Conditions Générales", href: cgu || "#" }}
        link2={{ label: "Mentions Légales", href: "/mentions-legales/" }}
        version={`V${pckg.version}${imagesDescription ? ` ${imagesDescription}` : ""
          }`}
        socials={socialLinks}
        languageOptions={languageOptions}
        currentLanguage={currentLanguage}
        onLanguageChange={handleLanguageChange}
      />
    </Box>
  );
};

export default Footer;